import React from "react";
import { CalendarCheck } from "lucide-react";
import { openEnquiry } from "./EnquiryModal";

// Vertical sticky tab (left edge, desktop only) that opens the enquiry popup
export default function EnquiryTab() {
  return (
    <button
      onClick={openEnquiry}
      aria-label="Open admission enquiry form"
      className="fixed left-0 top-1/2 z-[55] hidden -translate-y-1/2 items-center gap-2 rounded-r-xl px-3 py-5 lg:flex"
      style={{
        background: "var(--gold)",
        color: "#fff",
        writingMode: "vertical-rl",
        boxShadow: "0 14px 30px -14px rgba(192,138,46,.8)",
        transition: "padding .3s ease, background .3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.paddingLeft = "16px";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.paddingLeft = "12px";
      }}
    >
      <CalendarCheck size={16} style={{ transform: "rotate(90deg)" }} />
      <span className="text-[0.76rem] font-bold uppercase tracking-[0.16em]">Admission Enquiry</span>
    </button>
  );
}
